import CLIENT_ID from './CLIENT_ID'
import CLIENT_SECRET from './CLIENT_SECRET'
import sha256 from './sha256'
import api from 'js/api'

export const authenticateWithService = (service, data = {}) => {
  const timestamp = Date.now()
  const params = {
    oauth_service: service,
    platform: 'web',
    timestamp: timestamp,
    api_key: CLIENT_ID,
  }

  if (service === 'facebook') {
    params.oauth_token = data.token
    params.hash = sha256(`$${data.token}$${timestamp}$${CLIENT_SECRET}`)
    params.email = data.email
  }

  if (service === 'apple') {
    params.apple_userid = data.apple_uid
    params.hash = sha256(`$${data.apple_uid}$${timestamp}$${CLIENT_SECRET}`)
  }

  return api(
    'POST',
    'v2/accounts/authenticate',
    params
  ).then(({ response: { token, userid } }) => ({ token, userid }))
}
